import { safeJsonParse } from './safeJsonParse';
import { parseFilterValues } from './parseFilterValues';

export const parsePublicationSettings = (rawSettings) => {
  if (!rawSettings) return {};

  if (typeof rawSettings === 'object' && !Array.isArray(rawSettings)) {
    return rawSettings;
  }

  const text = String(rawSettings).trim();
  if (!text || (!text.startsWith('{') && !text.startsWith('['))) {
    return {};
  }

  return safeJsonParse(text, {});
};

export const getPublicationFilterD = (publicationSettings) => {
  const settings = parsePublicationSettings(publicationSettings);
  return settings.publication_filter_d ?? null;
};

const getCardFilterTag = (card) => String(card?.filterTag || card?.for_filter || '').trim();

export const matchAuthorAvatarsByFilterD = (filterD, authorCards) => {
  const filterDValues = parseFilterValues(filterD);
  if (filterDValues.length === 0 || !Array.isArray(authorCards)) {
    return [];
  }

  const matched = [];
  const seen = new Set();

  filterDValues.forEach((filterValue) => {
    const normalized = String(filterValue).trim().toLowerCase();
    if (!normalized || seen.has(normalized)) return;

    const card = authorCards.find((item) => getCardFilterTag(item).toLowerCase() === normalized);

    if (!card?.avatarImgUrl) return;

    seen.add(normalized);
    matched.push({
      filterTag: getCardFilterTag(card) || filterValue,
      avatarUrl: card.avatarImgUrl,
      name: card.name || filterValue,
    });
  });

  return matched;
};

export const getAuthorAvatarsFromPublication = (publication, authorCards) => {
  if (!publication?.publication_settings) return [];

  const settings = parsePublicationSettings(publication.publication_settings);
  return matchAuthorAvatarsByFilterD(settings.publication_filter_d, authorCards);
};
